import { Component, OnInit } from '@angular/core';
import {FileService} from "../../services/file.service";
import {Observable, map} from "rxjs";
import {FileRef} from "../../model/file-ref";
import {MatDialogRef, MatDialogModule} from "@angular/material/dialog";
import {MatTableModule} from "@angular/material/table";
import {MatButtonModule} from "@angular/material/button";
import {AsyncPipe} from "@angular/common";

@Component({
    selector: 'app-file-dialog',
    templateUrl: './file-dialog.component.html',
    styleUrls: ['./file-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        MatTableModule,
        MatButtonModule,
        AsyncPipe
    ]
})
export class FileDialogComponent implements OnInit {

  files$: Observable<FileRef[]>;

  constructor(
    public dialogRef: MatDialogRef<FileDialogComponent>,
    private fileService: FileService,
  ) { }

  ngOnInit(): void {
    this.files$ = this.fileService.getFiles().pipe(
      map(files => files.sort((a, b) => a.name.localeCompare(b.name)))
    );
  }

  select(file: FileRef): void {
    this.dialogRef.close(file);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
